//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniNumberBox from "@/components/uni-number-box/uni-number-box.vue"
export default {
	data(){
		return {
			carList:[],
			point:require('static/specialty/point.png'),
			pointa:require('static/specialty/pointa.png'),
			checked:false,
			payInfo: {
				price: 0,
				total: 0,
				checkList: [],
				isCar: true
			}
		}
	},
	components:{
		uniNumberBox
	},
	onReady() {
		this.queryData()
	},
	computed: {
		price () {
			let price = 0
			this.carList.forEach(element => {
				if (element.checked && element.stock !== 0 && element.isSelling !== 0) {
					price += parseFloat(element.singlePrice * element.quantity)
				}
				// element.checked = true
			})
			return price.toFixed(2)
		}
	  },
	methods:{
		bindChange(index,event){
			let _this=this
			let item = this.carList[index]
			if (event <= item.stock) {
				this.$ajax({
					method: 'post',
					url: '/weChat/specialtyProduct/updateCartInfo',
					data: {
						cartInfoId: item.id,
						number: event
					}
				}).then(res=>{
					_this.carList[index].quantity = event
				})
			} else {
				setTimeout(() => {
					this.carList[index].quantity = event
				}, 100)
			}
		  
		},
		submit(){
			this.payInfo.checkList=[]
			let stock=1
			this.carList.forEach(element => {
				if (element.checked && element.stock !== 0 && element.isSelling !== 0) {
					this.payInfo.checkList.push(element)
					this.payInfo.total += element.quantity
				} else if(element.checked&& element.stock==0){
					stock=0
				}
			})
			// return
			if (this.payInfo.checkList.length === 0||stock==0) {
				uni.showToast({
					title: '请选择商品或商品库存不足',
					icon:'none'
				})
				return false
			}
			let productId = this.payInfo.checkList.map(e => {
				return e.storeProductId
			}).join(',')
			this.payInfo.price = this.price
			uni.setStorageSync('payInfo',this.payInfo)
			uni.navigateTo({
				url:'/pages/specialty/pay'
			})
		},
		jump(item){
			if (item.stock !== 0 && item.isSelling === 1) {
				uni.navigateTo({
					url:'/pages/specialty/order?id='+item.storeProductId
				})
			}
		},
		check (index) {
			var lst = this.carList[index]
			if (lst.checked === true) {
				lst.checked = false
			} else {
				lst.checked = true
			}
			let checkedList = []
			this.carList.map(e => {
				if (e.checked) {
				checkedList.push(e.id)
				}
			})
			if (this.carList.length === checkedList.length) {
				this.checked = true
			} else {
				this.checked = false
			}
		},
		checkall(){
			if (this.checked === false) {
				this.carList.forEach(element => {
					element.checked = true
				})
				this.checked = true
			} else {
				this.carList.forEach(element => {
					element.checked = false
				})
				this.checked = false
			}
		},
		queryData () {
			let _this=this
			this.$ajax({
				method: 'post',
				url: '/weChat/specialtyProduct/queryCartInfoList',
				data: {
				// memberId: '599267700576878592',
				memberId: this.$store.state.userInfo.memberId,
				pageSize: 1000,
				currentPage: 1
				}
			}).then(res=>{
				if (res.data) {
					res.data.forEach(element => {
						element.coverImageUrl=element.coverImage
						element.checked = false
					})
				_this.carList = res.data
				}
			})
		},
		del(id, index){
			let _this=this
			uni.showModal({
				title: '提示',
				content: '确认删除该商品吗？',
				success: function (res) {
					if (res.confirm) {
						_this.$ajax({
							method: 'post',
							url: '/weChat/specialtyProduct/deletedCartInfo',
							data: {
								cartInfoId: id
							}
						}).then(res=>{
							_this.carList.splice(index, 1)
						})
					} else if (res.cancel) {
					}
				}
			})
		}
	}
}
